/**
 * Labstep
 *
 * @module prosemirror/components/Menu/Link/Action/Unlink
 * @desc Button to remove a link mark
 */

import { Button } from 'labstep-web/core/Button';
import { Icon } from 'labstep-web/core/Icon';
import { removeMarkFromSelectedNode } from 'labstep-web/prosemirror/utils/selection';
import type React from 'react';
import type { IMenuLinkActionUnlinkProps } from './types';

export const MenuLinkActionUnlink: React.FC<
  IMenuLinkActionUnlinkProps
> = ({ state, dispatch }) => (
  <Button
    onMouseDown={() => {
      removeMarkFromSelectedNode(state.schema.marks.link)(
        state,
        dispatch,
      );
    }}
  >
    <Icon name="unlink" />
    <span>Unlink</span>
  </Button>
);
